import { useMutation, useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { Team } from '../../database.schema';
import { getTourGroup } from '../utils/get-tour-group';

export type Price = {
  month: string;
  price: string;
};
export type Prices = Record<string, Price[]>;
export type Month = Record<string, string[]>;
export type MonthBookedAvailability = Record<string, number[]>;

type TeamData = {
  tournamentIndex: number;
  teamDetails: Team;
  team: string;
};

const mutateTeamName = async (teamData: TeamData): Promise<TeamData> => {
  const { tournamentIndex, teamDetails, team } = teamData;
  const authToken = Cookies.get('token');
  const tourGroup = getTourGroup();
  const path = `tournaments/${tourGroup}/${tournamentIndex}/ryderCup/${team}/.json`;
  var dbDNS = `https://golf-tour-462cf-default-rtdb.europe-west1.firebasedatabase.app/${path}?auth=${authToken}`;
  if (process.env.REACT_APP_MODE === 'dev') {
    dbDNS = `http://127.0.0.1:9000/${path}?ns=golf-tour-462cf-default-rtdb&auth=${authToken}`;
  }
  const response = await fetch(dbDNS, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...teamDetails }),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const useTeamNameMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mutateTeamName,
    onSuccess: (data) => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ['all-data'] });
    },
  });
};
